import { axiosInstance as axios, handleAxiosErrors } from '../_utils';
import config from '../store/_config';

export const axiosRequestReportRead = (payload) => {
  const { url } = config.report.read;
  const {
    reportType, 
    startDate, 
    endDate,
  } = payload;

  return axios.get(`${url}?type=${reportType}&from=${startDate}&to=${endDate}`, {
      withCredentials: true,
  });
};